import React from 'react'
import PeopleDetailFlyout from 'src/app/PeopleDetailFlyout/PeopleDetailFlyout'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import PeopleInvitedToOrgAppRoute from 'src/navigation/appRoutes/people/peopleInvitedToOrg.appRoute'
import PeopleMembersAppRoute from 'src/navigation/appRoutes/people/peopleMembers.appRoute'
import { peopleInvitedToOrgDetailRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const PeopleInvitedToOrgDetailAppRoute: AppRoute = {
  id: AppLocation.PeopleInvitedToOrgDetail,
  routeProps: peopleInvitedToOrgDetailRouteProps,
  component: <PeopleDetailFlyout invitedFlyout />,
  subRoutes: [],
  exceptions: [PeopleMembersAppRoute, PeopleInvitedToOrgAppRoute],
  meta: { contentType: SidenavContentType.Main },
}

export default PeopleInvitedToOrgDetailAppRoute
